export default __webpack_public_path__ + "static/media/Ch_2020-7-1.c701d812.png";